module.exports = __webpack_public_path__ + "img/DiningHall.ed4e8bca.jpg";